"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _store = _interopRequireWildcard(require("@/api/store"));
var storeApi = _store;
var _componentsApi = require("@/api/componentsApi");
var _api = _interopRequireWildcard(require("./api"));
var disApi = _api;
var _enum = require("../enum");
var _validate = require("@/utils/validate.js");
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _exportProgress = _interopRequireDefault(require("@/mixins/exportProgress"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != _typeof(t) || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var _default = exports.default = {
  mixins: [_exportProgress.default],
  data: function data() {
    return {
      title: '',
      //弹窗
      platformStatusEnum: _enum.platformStatusEnum,
      supperStatusEnum: _enum.supperStatusEnum,
      props: {
        children: 'child',
        label: 'name',
        value: 'id',
        emitPath: false
      },
      tableData: {
        list: [],
        total: 0
      },
      merCateList: [],
      pageFrom: {
        page: 1,
        limit: 15
      },
      searchOptions: [],
      searchLoading: false,
      collapse: false,
      labelLists: [],
      loading: false,
      // 表格loading
      customerId: null,
      ids: [],
      brandList: [],
      suppliers: [],
      homeType: false,
      ljcType: null,
      // 导入任务进度（独立于导出进度，避免互相干扰）
      importProgress: {
        visible: false,
        title: '',
        percentage: 0,
        statusText: '',
        isError: false,
        isSuccess: false,
        canCancel: false
      }
    };
  },
  created: function created() {
    if (this.$getHomeType()) {
      this.ljcType = this.$getHomeType().type;
      console.log("this.ljcType>>>>>", this.ljcType);
    }
    this.remoteMethod();
    this.title = this.$route.query.name;
    this.customerId = this.$route.query.id;
    this.getCategorySelect();
    this.getBrandList();
    this.getSupplierList();
    this.getList();
  },
  mounted: function mounted() {
    var JavaInfo = JSON.parse(_jsCookie.default.get('JavaInfo'));
    console.log(JavaInfo, 'JavaInfo');
    this.homeType = JavaInfo.homeType === 2;
    this.DeleteCouponVueRef = this.$refs.DeleteCouponVueRef;
  },
  methods: {
    openSyncConfirm: function openSyncConfirm(_ref) {
      var title = _ref.title,
        _ref$needStoreId = _ref.needStoreId,
        needStoreId = _ref$needStoreId === void 0 ? false : _ref$needStoreId;
      var defaultStoreId = this.$route.query.storeId || '';
      return this.$refs.SyncConfirmRef.open({
        title: title,
        needStoreId: needStoreId,
        defaultStoreId: defaultStoreId
      });
    },
    search: function search() {
      this.pageFrom.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(size) {
      this.pageFrom.limit = size;
      this.getList();
    },
    pageChange: function pageChange(page) {
      this.pageFrom.page = page;
      this.getList();
    },
    // 品牌
    getBrandList: function () {
      var _getBrandList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(params) {
        var res, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return (0, _api.getBrandrApi)(params);
            case 1:
              res = _context.v;
              this.brandList = res || [];
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              this.$message.error(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, this, [[0, 2]]);
      }));
      function getBrandList(_x) {
        return _getBrandList.apply(this, arguments);
      }
      return getBrandList;
    }(),
    //远程搜索品牌
    brandRemoteMethod: function brandRemoteMethod(query) {
      if (query !== '') {
        this.getBrandList({
          keyword: query
        });
      }
    },
    //供应商
    getSupplierList: function () {
      var _getSupplierList = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(params) {
        var res, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              _context2.p = 0;
              _context2.n = 1;
              return (0, _api.getSupplierApi)(params);
            case 1:
              res = _context2.v;
              this.suppliers = res || [];
              _context2.n = 3;
              break;
            case 2:
              _context2.p = 2;
              _t2 = _context2.v;
              this.$message.error(_t2);
            case 3:
              return _context2.a(2);
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function getSupplierList(_x2) {
        return _getSupplierList.apply(this, arguments);
      }
      return getSupplierList;
    }(),
    //远程搜素供应商
    supplierRemoteMethod: function supplierRemoteMethod() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (query !== '') {
        this.getSupplierList({
          keyword: query
        });
      }
    },
    //导出
    exportCustomerSku: function () {
      var _exportCustomerSku = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var params;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              params = _objectSpread(_objectSpread(_objectSpread({}, this.pageFrom), this.searchForm), {}, {
                customerId: this.customerId
              });
              _context3.n = 1;
              return this.startExportWithProgress(function () {
                return (0, _api.exportCustomerSkuApi)(params);
              }, {
                title: '导出客户SKU数据',
                fileName: '客户SKU数据.xlsx',
                estimatedDuration: 3000
              });
            case 1:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function exportCustomerSku() {
        return _exportCustomerSku.apply(this, arguments);
      }
      return exportCustomerSku;
    }(),
    //导出最低价SKU
    exportLowestPriceSku: function () {
      var _exportLowestPriceSku = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var params;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              params = _objectSpread(_objectSpread(_objectSpread({}, this.pageFrom), this.searchForm), {}, {
                customerId: this.customerId
              });
              _context4.n = 1;
              return this.startExportWithProgress(function () {
                return (0, _api.exportLowestPriceSkuApi)(params);
              }, {
                title: '导出最低价SKU',
                fileName: '最低价SKU.xlsx',
                estimatedDuration: 4000
              });
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function exportLowestPriceSku() {
        return _exportLowestPriceSku.apply(this, arguments);
      }
      return exportLowestPriceSku;
    }(),
    //导出模板
    exportTemp: function () {
      var _exportTemp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return this.startExportWithProgress(function () {
                return (0, _componentsApi.excelTemplateApi)('customerSku.xlsx');
              }, {
                title: '导出模板',
                fileName: '客户SKU模板.xlsx',
                estimatedDuration: 2000
              });
            case 1:
              return _context5.a(2);
          }
        }, _callee5, this);
      }));
      function exportTemp() {
        return _exportTemp.apply(this, arguments);
      }
      return exportTemp;
    }(),
    //列表选择
    handleSelectionChange: function handleSelectionChange(val) {
      this.ids = val.map(function (item) {
        return item.id;
      });
    },
    //批量移除
    deleteBatch: function deleteBatch() {
      var _this = this;
      if (this.ids.length == 0) {
        this.$message.error('请选择要删除的数据！');
        return;
      }
      this.$alert('确定要删除吗？', '批量删除', {
        confirmButtonText: '确定',
        callback: function () {
          var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
            var res, _t3;
            return _regenerator().w(function (_context6) {
              while (1) switch (_context6.p = _context6.n) {
                case 0:
                  _context6.p = 0;
                  _context6.n = 1;
                  return (0, _api.deleteBatchApi)(_this.ids);
                case 1:
                  res = _context6.v;
                  _this.$message.success('批量删除成功！');
                  _this.search();
                  _context6.n = 3;
                  break;
                case 2:
                  _context6.p = 2;
                  _t3 = _context6.v;
                  _this.$message.error(_t3.message);
                case 3:
                  return _context6.a(2);
              }
            }, _callee6, null, [[0, 2]]);
          }));
          function callback() {
            return _callback.apply(this, arguments);
          }
          return callback;
        }()
      });
    },
    //商家状态
    onchangeStatus: function () {
      var _onchangeStatus = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(row) {
        var _t4;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              _context7.p = 0;
              _context7.n = 1;
              return (0, _api.updateStatusApi)({
                id: row.id,
                status: row.status
              });
            case 1:
              this.getList();
              _context7.n = 3;
              break;
            case 2:
              _context7.p = 2;
              _t4 = _context7.v;
              this.getList();
              console.log(_t4);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this, [[0, 2]]);
      }));
      function onchangeStatus(_x3) {
        return _onchangeStatus.apply(this, arguments);
      }
      return onchangeStatus;
    }(),
    // 商品分类；
    getCategorySelect: function getCategorySelect() {
      var _this2 = this;
      (0, _store.categoryApi)({
        status: -1,
        type: 1
      }).then(function (res) {
        _this2.merCateList = res;
      }).catch(function (res) {
        _this2.$message.error(res.message);
      });
    },
    // 归属公司
    remoteMethod: function remoteMethod(query) {
      var _this3 = this;
      this.searchLoading = true;
      (0, _api.getCompanyListApi)(query).then(function (res) {
        _this3.searchOptions = res.total ? res.list : res;
        _this3.searchLoading = false;
      }).catch(function () {
        _this3.$message.error('请求失败，请稍后再试');
        _this3.searchLoading = false;
      });
    },
    //新增
    addGoods: function addGoods(type) {
      this.$refs.AddGoodsVueRef.open(type);
    },
    // 删除记录
    deleteRecode: function deleteRecode(row) {
      this.$refs.DeleteCouponVueRef.open(row);
    },
    //详情
    detail: function detail(row) {},
    // 列表
    getList: function getList() {
      var _this4 = this;
      this.loading = true;
      (0, _api.customerSkuPageApi)(_objectSpread(_objectSpread({}, this.pageFrom), {}, {
        customerId: this.customerId
      })).then(function (res) {
        _this4.tableData = res;
        _this4.tableData.list = res.list;
        _this4.loading = false;
      }).catch(function (err) {
        _this4.loading = false;
      });
    },
    changePrice: (0, _validate.Debounce)(/*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(row) {
        var _this5 = this;
        var data;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              data = _objectSpread({}, row);
              if (this.hasConfirm == 1) {
                data['hasConfirm'] = this.hasConfirm;
              }
              ;
              (0, _api.updatePriceApi)(row).then(function (res) {
                _this5.$message.success('价格更新成功！');
                _this5.getList();
                _this5.hasConfirm = null;
              }).catch(function (err) {
                var _ref3 = err && err.data || {},
                  code = _ref3.code,
                  msg = _ref3.msg;
                if (code == 601 && !_this5.hasConfirm) {
                  storeApi.checkComfirm(msg).then(function (res) {
                    _this5.hasConfirm = res && res.hasConfirm;
                    _this5.changePrice();
                  });
                } else {
                  _this5.getList();
                }
              });
            case 1:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      return function (_x4) {
        return _ref2.apply(this, arguments);
      };
    }(), 1000),
    changeVirtualSales: (0, _validate.Debounce)(function (row) {
      var _this6 = this;
      if (row.virtualSales === null || row.virtualSales === undefined || row.virtualSales === '') {
        this.$message.error('虚拟销量不能为空');
        return;
      }
      (0, _api.updateVirtualSalesApi)({
        id: row.id,
        virtualSales: row.virtualSales
      }).then(function () {
        _this6.$message.success('虚拟销量更新成功！');
        _this6.getList();
      }).catch(function () {
        _this6.getList();
      });
    }, 1000),
    // 导入
    beforeUpload: function () {
      var _beforeUpload = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(file, type, oldFormaData) {
        var formData, _t5, _t6;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.p = _context9.n) {
            case 0:
              formData = null;
              if (file) {
                formData = new FormData();
                formData.append('file', file);
              } else if (oldFormaData) {
                formData = oldFormaData;
              }
              ;
              _context9.p = 1;
              _t5 = type;
              _context9.n = _t5 === 'updatePriceApi' ? 2 : _t5 === 'updateStatusApi' ? 4 : _t5 === 'updateCustomerSkuApi' ? 6 : 8;
              break;
            case 2:
              _context9.n = 3;
              return this.importHander('importUpdatePriceApi', 'updatePriceApi', formData);
            case 3:
              return _context9.a(3, 10);
            case 4:
              _context9.n = 5;
              return this.importData(_api.importUpdateStatusApi, formData, Number(this.customerId));
            case 5:
              return _context9.a(3, 10);
            case 6:
              _context9.n = 7;
              return this.startImportUpdateCustomerSku(formData);
            case 7:
              return _context9.a(3, 10);
            case 8:
              _context9.n = 9;
              return this.importHander('importCustomerSkuApi', '', formData);
            case 9:
              return _context9.a(3, 10);
            case 10:
              return _context9.a(2, true);
            case 11:
              _context9.p = 11;
              _t6 = _context9.v;
              throw _t6;
            case 12:
              return _context9.a(2);
          }
        }, _callee9, this, [[1, 11]]);
      }));
      function beforeUpload(_x5, _x6, _x7) {
        return _beforeUpload.apply(this, arguments);
      }
      return beforeUpload;
    }(),
    importHander: function () {
      var _importHander = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(methodName, type, formData) {
        var res, _ref4, code, msg, confirmRes, _t7;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.p = _context0.n) {
            case 0:
              _context0.p = 0;
              _context0.n = 1;
              return disApi[methodName](formData, Number(this.customerId), this.hasConfirm == 1 ? this.hasConfirm : null);
            case 1:
              res = _context0.v;
              this.$message.success('导入成功！');
              this.search();
              this.hasConfirm = null;
              return _context0.a(2, res);
            case 2:
              _context0.p = 2;
              _t7 = _context0.v;
              _ref4 = _t7 && _t7.data || {}, code = _ref4.code, msg = _ref4.msg;
              if (!(code == 601 && !this.hasConfirm)) {
                _context0.n = 5;
                break;
              }
              _context0.n = 3;
              return storeApi.checkComfirm(msg);
            case 3:
              confirmRes = _context0.v;
              this.hasConfirm = confirmRes && confirmRes.hasConfirm;
              _context0.n = 4;
              return this.beforeUpload(null, type, formData);
            case 4:
              return _context0.a(2, _context0.v);
            case 5:
              throw _t7;
            case 6:
              return _context0.a(2);
          }
        }, _callee0, this, [[0, 2]]);
      }));
      function importHander(_x8, _x9, _x0) {
        return _importHander.apply(this, arguments);
      }
      return importHander;
    }(),
    importData: function () {
      var _importData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(api, formData, id) {
        var res, _t8;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.p = _context1.n) {
            case 0:
              _context1.p = 0;
              _context1.n = 1;
              return api(formData, id);
            case 1:
              res = _context1.v;
              this.$message.success('导入成功！');
              this.search();
              return _context1.a(2, res);
            case 2:
              _context1.p = 2;
              _t8 = _context1.v;
              this.$message.error(_t8);
              throw _t8;
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this, [[0, 2]]);
      }));
      function importData(_x1, _x10, _x11) {
        return _importData.apply(this, arguments);
      }
      return importData;
    }(),
    syncRenshouProduct: function () {
      var _syncRenshouProduct = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var _yield$this$openSyncC, syncType, storeId, _t9;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.p = _context10.n) {
            case 0:
              _context10.p = 0;
              _context10.n = 1;
              return this.openSyncConfirm({
                title: '同步仁寿商品',
                needStoreId: true
              });
            case 1:
              _yield$this$openSyncC = _context10.v;
              syncType = _yield$this$openSyncC.syncType;
              storeId = _yield$this$openSyncC.storeId;
              if (storeId) {
                _context10.n = 2;
                break;
              }
              this.$message.error('店铺ID(storeId)不能为空');
              return _context10.a(2);
            case 2:
              _context10.n = 3;
              return (0, _api.syncCategoryApi)({
                syncType: syncType
              });
            case 3:
              _context10.n = 4;
              return (0, _api.syncProductApi)({
                storeId: Number(storeId),
                customerId: Number(this.customerId),
                syncType: syncType
              });
            case 4:
              this.$message.success('同步任务已启动（先分类后商品），可在日志中查看最新进度');
              this.search();
              _context10.n = 6;
              break;
            case 5:
              _context10.p = 5;
              _t9 = _context10.v;
              if (_t9 !== 'cancel' && _t9 !== 'close') {
                this.$message.error(_t9.message || '同步失败');
              }
            case 6:
              return _context10.a(2);
          }
        }, _callee10, this, [[0, 5]]);
      }));
      function syncRenshouProduct() {
        return _syncRenshouProduct.apply(this, arguments);
      }
      return syncRenshouProduct;
    }(),
    viewRenshouSyncLog: function viewRenshouSyncLog() {
      this.$refs.RenshouSyncLogRef.open();
    },
    /**
     * 提交「更新商品」Excel，拿到 taskId 后立即返回，让上传组件结束等待，
     * 同时在后台启动轮询，用独立进度条展示真实处理进度。
     */
    startImportUpdateCustomerSku: function () {
      var _startImportUpdateCustomerSku = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(formData) {
        var res, _ref5, taskId, _ref5$totalCount, totalCount;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              _context11.n = 1;
              return (0, _api.importUpdateCustomerSkuApi)(formData, Number(this.customerId), null);
            case 1:
              res = _context11.v;
              _ref5 = res || {}, taskId = _ref5.taskId, _ref5$totalCount = _ref5.totalCount, totalCount = _ref5$totalCount === void 0 ? 0 : _ref5$totalCount;
              if (taskId) {
                _context11.n = 2;
                break;
              }
              // 兼容旧接口（同步版本直接返回成功的情况）
              this.$message.success('导入成功！');
              this.search();
              return _context11.a(2);
            case 2:
              // 显示进度条，开始轮询
              this.importProgress = {
                visible: true,
                title: '导入更新商品',
                percentage: 5,
                statusText: "\u5DF2\u63D0\u4EA4 ".concat(totalCount, " \u6761\u6570\u636E\uFF0C\u540E\u53F0\u5904\u7406\u4E2D\u2026"),
                isError: false,
                isSuccess: false,
                canCancel: false
              };
              this._startImportPolling(taskId, totalCount);
            case 3:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function startImportUpdateCustomerSku(_x12) {
        return _startImportUpdateCustomerSku.apply(this, arguments);
      }
      return startImportUpdateCustomerSku;
    }(),
    /**
     * 递归 setTimeout 轮询任务状态，每秒查询一次，最多等待 3 分钟。
     * 用 setTimeout 而非 setInterval，确保上一次请求结束后再发下一次。
     */
    _startImportPolling: function _startImportPolling(taskId, totalCount) {
      var _this7 = this;
      // 清理上一轮残留的定时器（防止页面反复操作产生多个轮询）
      this._stopImportPolling();
      var pollCount = 0;
      var MAX_POLLS = 180; // 最多 180 秒

      var _tick = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12() {
          var statusRes, _ref7, status, message, _ref7$processedCount, processedCount, progress, _t0;
          return _regenerator().w(function (_context12) {
            while (1) switch (_context12.p = _context12.n) {
              case 0:
                pollCount++;
                if (!(pollCount > MAX_POLLS)) {
                  _context12.n = 1;
                  break;
                }
                _this7._finishImportProgress(false, '查询超时，请稍后刷新列表确认结果');
                return _context12.a(2);
              case 1:
                _context12.p = 1;
                _context12.n = 2;
                return (0, _api.importUpdateCustomerSkuStatusApi)(taskId);
              case 2:
                statusRes = _context12.v;
                _ref7 = statusRes || {}, status = _ref7.status, message = _ref7.message, _ref7$processedCount = _ref7.processedCount, processedCount = _ref7$processedCount === void 0 ? 0 : _ref7$processedCount;
                if (status === 'SUCCESS') {
                  _this7._finishImportProgress(true, "\u6210\u529F\u5904\u7406 ".concat(processedCount, " \u6761"));
                  _this7.search();
                } else if (status === 'FAILED') {
                  _this7._finishImportProgress(false, message || '导入失败，请检查数据后重试');
                } else {
                  // PROCESSING：用轮询次数模拟进度，上限 90%，留 10% 给最终完成
                  progress = Math.min(90, Math.round(pollCount / MAX_POLLS * 90) + 5);
                  _this7.importProgress.percentage = progress;
                  _this7.importProgress.statusText = "\u5904\u7406\u4E2D\u2026 \u5DF2\u7B49\u5F85 ".concat(pollCount, "s");
                  _this7._importPollTimer = setTimeout(_tick, 1000);
                }
                _context12.n = 4;
                break;
              case 3:
                _context12.p = 3;
                _t0 = _context12.v;
                // 网络抖动时最多重试 3 次，超过再报错
                if (pollCount <= 3) {
                  _this7._importPollTimer = setTimeout(_tick, 2000);
                } else {
                  _this7._finishImportProgress(false, '状态查询失败：' + (_t0.message || _t0));
                }
              case 4:
                return _context12.a(2);
            }
          }, _callee12, null, [[1, 3]]);
        }));
        return function tick() {
          return _ref6.apply(this, arguments);
        };
      }();
      this._importPollTimer = setTimeout(_tick, 1000);
    },
    _stopImportPolling: function _stopImportPolling() {
      if (this._importPollTimer) {
        clearTimeout(this._importPollTimer);
        this._importPollTimer = null;
      }
    },
    _finishImportProgress: function _finishImportProgress(success, text) {
      this._stopImportPolling();
      this.importProgress.percentage = success ? 100 : this.importProgress.percentage;
      this.importProgress.statusText = text;
      this.importProgress.isSuccess = success;
      this.importProgress.isError = !success;
      if (success) {
        this.$message.success('导入成功！');
      } else {
        this.$message.error(text);
      }
    },
    handleImportProgressClose: function handleImportProgressClose() {
      this._stopImportPolling();
      this.importProgress = {
        visible: false,
        title: '',
        percentage: 0,
        statusText: '',
        isError: false,
        isSuccess: false,
        canCancel: false
      };
    }
  },
  beforeDestroy: function beforeDestroy() {
    // 页面销毁时清理定时器，避免内存泄漏
    this._stopImportPolling();
  }
};